module.exports = __webpack_public_path__ + "static/media/logo.ba6221ef.svg";